module.exports = __webpack_public_path__ + "static/img/componey_img.461d24f9.png";